import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Book from "../ui/Book";

export default function Features({ books }) {
  const featuredBooks = books.filter((book) => book.rating === 5).slice(0, 4);

  return (
    <section id="features">
      <div className="container">
        <div className="row">
          <h2 className="section__title">
            Featured <span className="purple">Books</span>
          </h2>
          <div className="books">
            {featuredBooks.map((book) => (
              <Book key={book.id} book={book} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
